import { NeutralButton } from "./Buttons"
import { useTranslation } from "react-i18next"
import ReusableDrawer from "./ReusableDrawer"
import { colors } from "../../utilities/colors"

export default function ActionConfirmDrawer({body, isOpen, bgColor, onClose, title, onConfirm, onCancel, showSpinner = false, confirmText = null, cancelText = null, subtext = null}) {
  const { t } = useTranslation()

  return(
      <ReusableDrawer
        isOpen={isOpen}
        onClose={onClose}
        placement={'bottom'}
        bodyContent={body}
        title={title}
        bgColor={bgColor}
        titleStyle={"flex items-center justify-center w-full"}
        bodyStyle="flex flex-col items-center justify-center text-center"
        footerStyle="flex items-center justify-center w-full"
        footerContent={
          <div className="flex my-4">
            <NeutralButton
              text={confirmText || t('Confirm')}
              onClick={onConfirm}
              style="mx-4"
            />
            <NeutralButton
              text={cancelText || t('Cancel')}
              onClick={onCancel}
              style="mx-4"
            />
          </div>
        }
      />
  )

}